import type { IconName } from "@/components/icons/Icon";

const DEFAULT_ICON: IconName = "chat/files/File";

const ICON_RULES: {
  icon: IconName;
  mimePrefix?: string;
  mimes?: string[];
  extensions: string[];
}[] = [
  {
    icon: "chat/files/Image",
    mimePrefix: "image/",
    extensions: ["png", "jpg", "jpeg", "gif", "webp", "svg", "bmp", "ico", "avif", "heic"],
  },
  {
    icon: "chat/files/Video",
    mimePrefix: "video/",
    extensions: ["mp4", "mov", "mkv", "webm", "avi", "m4v"],
  },
  {
    icon: "chat/files/Audio",
    mimePrefix: "audio/",
    extensions: ["mp3", "wav", "ogg", "flac", "m4a", "aac"],
  },
  {
    icon: "chat/files/Pdf",
    mimes: ["application/pdf"],
    extensions: ["pdf"],
  },
  {
    icon: "chat/files/Spreadsheet",
    mimes: [
      "text/csv",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.oasis.opendocument.spreadsheet",
    ],
    extensions: ["csv", "tsv", "xls", "xlsx", "ods"],
  },
  {
    icon: "chat/files/Latex",
    mimes: ["application/x-tex", "text/x-tex", "application/x-latex"],
    extensions: ["tex", "sty", "cls"],
  },
  {
    icon: "chat/files/Code",
    mimes: ["application/json", "application/xml", "text/xml", "text/javascript"],
    extensions: [
      "js",
      "mjs",
      "cjs",
      "jsx",
      "ts",
      "tsx",
      "py",
      "rb",
      "go",
      "rs",
      "java",
      "kt",
      "c",
      "h",
      "cpp",
      "cc",
      "hpp",
      "cs",
      "php",
      "swift",
      "sh",
      "bash",
      "zsh",
      "json",
      "yaml",
      "yml",
      "toml",
      "xml",
      "html",
      "css",
      "scss",
      "sass",
      "less",
      "sql",
    ],
  },
];

export function getFileIconName({ type, name }: { type: string; name: string }): IconName {
  const byMime = ICON_RULES.find(
    ({ mimePrefix, mimes }) => (mimePrefix && type.startsWith(mimePrefix)) || mimes?.includes(type),
  );
  if (byMime) return byMime.icon;

  return (
    ICON_RULES.find(({ extensions }) => extensions.includes(getExtension(name)))?.icon ??
    DEFAULT_ICON
  );
}

export function getExtension(name: string): string {
  return name.split(".").slice(1).pop()?.toLowerCase() ?? "";
}
